import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CButton } from '@coreui/react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import {
  selectOrgHierarchyRootOrg,
  selectOrgHierarchySelectedOrg,
} from '../../../store/selectors/orgHierarchy.selectors';
import { OpenModal } from '../../../store/actions/modal.action';
import { ModalName } from '../../models/modal';


const OrgHierarchyButton = (props: any) => {
   const {
     className,
     title,
     buttonClassName,
   } = props;
   const {
     enableOrgHierarchyModule
   } = useFlags();
  const dispatch = useDispatch();
  const selectedOrg = useSelector(selectOrgHierarchySelectedOrg);
  const orgHierarchyRootOrg = useSelector(selectOrgHierarchyRootOrg);
  const isOrgHierarchy = orgHierarchyRootOrg?.tags?.indexOf('view:list') > -1;

  return (isOrgHierarchy && enableOrgHierarchyModule) ? (
    <div className={`glympse-orgHierarchy glympse-text-orange ${className}`}>
      {!title && <span className="glympse-orgHierarchy-title">Now viewing:</span>}
      <CButton
        onClick={() => dispatch(new OpenModal(ModalName.OrgHierarchy, {}))}
        className={`glympse-orgHierarchy-button text-white outline ${buttonClassName}`}
      >
        <div className="glympse-orgHierarchy-button-text">{title || selectedOrg?.name}</div>
        <span>&rang;</span>
      </CButton>
    </div>
  ) : null
};

export default OrgHierarchyButton;
